export default "__VITE_ASSET__jg8VJrUw__"